class WIquickAdd extends HTMLElement{
    constructor(){
        super();
    }
    connectedCallback() {
        this.clickOnSingleVariant();
    }
    clickOnSingleVariant() {
        let varBtn = this.querySelectorAll('.WI_quickAdd_atc');
        varBtn.forEach(variant => {
            variant.addEventListener('click', async (e)=>{
                e.preventDefault();
                let loadingCartBlock = document.querySelector('.WI_loadingCartItemBlock');
                let emptyCart =  document.querySelector('.WI_cartDrawerin_cart_empty');
                if (loadingCartBlock != null) {
                    loadingCartBlock.style.display = "block";
                }
                if (emptyCart != null) {
                    emptyCart.style.display = "none";
                }
                let variantId = variant.getAttribute('data-variantid');
                let formData = {
                    'items': [{
                        "id": variantId,
                        "quantity": 1
                    }]
                };
                await fetch('/cart/add',{
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                });   
                fetch(`${routes.cart_url}?section_id=cart-drawer`)
                .then((response) => response.text())
                .then((responseText) => {
                  document.querySelector('cart-drawer').open();
                  const html = new DOMParser().parseFromString(responseText, 'text/html');
                  const total_items = html.querySelector('.drawer-items-count').value;
                  const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
                  for (const selector of selectors) {
                    const targetElement = document.querySelector(selector);
                    const sourceElement = html.querySelector(selector);
                    if (targetElement && sourceElement) {
                      targetElement.outerHTML = sourceElement.outerHTML;
                    }
                  }
                  if(total_items > 0){
                    document.querySelector('cart-drawer').classList.remove('is-empty');
                    document.querySelector('.drawer__inner-empty').remove();
                  }
                })
                .catch((e) => {
                  console.error(e);
                });
                fetch(`${routes.cart_url}?section_id=cart-icon-bubble`)
                .then((response) => response.text())
                .then((responseText) => {
                  const html = new DOMParser().parseFromString(responseText, 'text/html');
                  const targetElement = document.querySelector('#cart-icon-bubble');
                  const sourceElement = html.querySelector('#shopify-section-cart-icon-bubble');
                  targetElement.innerHTML = sourceElement.innerHTML;
                })
                .catch((e) => {
                  console.error(e);
                });
            });
        });
    };
}

customElements.define("wi-quickadd", WIquickAdd);